import { useField } from "formik"
import { AutoComplete } from "primereact/autocomplete"
import { useEffect } from "react"

const FormikAutoComplete = ({
  id,
  autoFocus,
  completeMethod,
  maxLength,
  suggestions,
  onSelect,
  forceSelection = false,
  disabled = false,
  className,
  dropdown = false,
  isCif = false,
  showError = true,
  placeholder,
  ...props
}: $TSMigrationFixMe) => {
  const [field, meta, helpers] = useField(props)
  const errorMsg = meta.error && meta.touched ? meta.error : ""

  const getCifFormatted = (text: $TSMigrationFixMe) =>
    text?.value?.replace(/[^\w\s ]/gi, "")?.replace(" ", "")

  useEffect(() => {
    if (!isCif || !field.value) return
    const fieldFormat = getCifFormatted(field)
    helpers.setValue(fieldFormat)
  }, []) // eslint-disable-line

  return (
    <>
      <AutoComplete
        id={id}
        forceSelection={forceSelection}
        maxlength={maxLength}
        autoFocus={autoFocus}
        suggestions={suggestions}
        onSelect={onSelect}
        className={`${errorMsg ? "p-invalid" : ""} ${className}`}
        disabled={disabled}
        dropdown={dropdown}
        {...field}
        placeholder={placeholder}
        completeMethod={(e) => completeMethod(e.query)}
        onChange={(e) => helpers.setValue(isCif ? getCifFormatted(e) : e.value)}
      />
      {errorMsg && showError && (
        <small className='p-error p-d-block'>{errorMsg}</small>
      )}
    </>
  )
}

export default FormikAutoComplete
